var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("validation-observer", {
    ref: "question",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ errors: errorsQuestion }) {
          return [
            _c(
              "ordered-header-card",
              {
                staticClass: "proposal-evaluation-question",
                attrs: { "is-ordered": false, order: _vm.questionOrder }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "proposal-evaluation-question__body",
                    attrs: { slot: "content" },
                    slot: "content"
                  },
                  [
                    _c("p", {
                      staticClass:
                        "proposal-evaluation-question__body__question",
                      domProps: { innerHTML: _vm._s(_vm.questionName) }
                    }),
                    _vm.question.additionalQuestions.length > 0
                      ? _c(
                          "div",
                          { staticClass: "row mb-2" },
                          _vm._l(_vm.additionalFields, function(sub, index) {
                            return _c(
                              "div",
                              {
                                key: sub.proposalEvaluationAdditionalQuestionId,
                                staticClass: "col-12 mb-2",
                                class: {
                                  "col-md-6":
                                    _vm.question.additionalQuestions.length > 1
                                }
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 custom-control-inline"
                                    },
                                    [
                                      _c("label", { staticClass: "mr-2" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              sub.additionalQuestionDescription
                                            ) +
                                            " "
                                        )
                                      ]),
                                      _c("validation-provider", {
                                        staticClass: "input",
                                        attrs: {
                                          name: `section-${_vm.question.sectionId}-question-${_vm.question.questionId}-additionalQuestions-${sub.additionalQuestionId}`,
                                          rules: "required"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function({ errors }) {
                                                return [
                                                  _c("custom-input", {
                                                    attrs: {
                                                      "custom-error-msg": "",
                                                      disabled: _vm.readOnly,
                                                      error: errors[0],
                                                      type: "text"
                                                    },
                                                    on: {
                                                      input: _vm.emitTouched
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.additionalFields[
                                                          index
                                                        ].answer,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.additionalFields[
                                                            index
                                                          ],
                                                          "answer",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "additionalFields[index].answer"
                                                    }
                                                  })
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    Object.values(errorsQuestion).flat(1)[0]
                      ? _c("error", {
                          attrs: {
                            message: _vm.customErrorMsg,
                            variant: "no-border"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "proposal-evaluation-question__actions",
                    attrs: { slot: "actions" },
                    slot: "actions"
                  },
                  [
                    _c("validation-provider", {
                      attrs: {
                        name: `section-${_vm.question.sectionId}-question-${_vm.question.questionId}`,
                        rules: "required"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-radio", {
                                  staticClass:
                                    "proposal-evaluation-question__custom-radio",
                                  class: {
                                    "proposal-evaluation-question__custom-radio--error":
                                      errors[0] && !_vm.selectedAnswer
                                  },
                                  attrs: {
                                    id: `rbtn-${
                                      _vm.question.questionId
                                    }-${Math.random()}`,
                                    "change-event": _vm.onSelectedAnswers,
                                    "custom-error-msg": " ",
                                    "custom-style": {
                                      separator: "0px",
                                      radioButtonWidth: "85px",
                                      centerBorderRadius: true
                                    },
                                    disabled: _vm.readOnly,
                                    error: false,
                                    "is-inline": true,
                                    name: "evaluationQuestions",
                                    options: _vm.radioOptions,
                                    type: "questions"
                                  },
                                  model: {
                                    value: _vm.selectedAnswer,
                                    callback: function($$v) {
                                      _vm.selectedAnswer = $$v
                                    },
                                    expression: "selectedAnswer"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                )
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }